import { render, staticRenderFns } from "./TextGeneral.vue?vue&type=template&id=67eef452&scoped=true&"
import script from "./TextGeneral.vue?vue&type=script&lang=js&"
export * from "./TextGeneral.vue?vue&type=script&lang=js&"
import style0 from "./TextGeneral.vue?vue&type=style&index=0&id=67eef452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67eef452",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/uu264406/workDirectory/shingaku/reset_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67eef452')) {
      api.createRecord('67eef452', component.options)
    } else {
      api.reload('67eef452', component.options)
    }
    module.hot.accept("./TextGeneral.vue?vue&type=template&id=67eef452&scoped=true&", function () {
      api.rerender('67eef452', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/contents/components/pages/signUp/common/TextGeneral.vue"
export default component.exports